<div class="boas-vindas" *ngIf="usuarioInformacoes.boasVindas">
  <div class="modal">
    <div class="modal-content">
      <div class="row">
        <div class="col-md-10"></div>
        <div class="col-md-2">
          <div (click)="pularTutorial()" class="texto-pular"><i class="fa fa-close"></i> Pular o tutorial</div>
        </div>

      </div>
      <div class="row" style="height: 100%">
        <div class="col-md-12" >
          <ng-container *ngIf="primeiraPagina">
            <h4><i class="fa fa-balance-scale"></i> Bem-vindo ao LawServices! <i class="fa fa-balance-scale"></i></h4>
            <br>
            <p>Estamos felizes em tê-lo(a) conosco. Nosso objetivo é simplificar a gestão do seu escritório de advocacia,
              oferecendo ferramentas eficientes e práticas para organizar sua agenda, monitorar processos, armazenar
              documentos e melhorar a comunicação com seus clientes.</p>
            <div class="imagem">
              <img src="/assets/emailconfirmado.png" width="500"  alt="tela de atendimento"/>
            </div>
            <p>Explore todas as funcionalidades do LawServices e veja como podemos transformar sua rotina de trabalho.
              Se precisar de ajuda, nossa equipe de suporte está à disposição.</p>
          </ng-container>
          <ng-container *ngIf="segundaPagina">
            <p>Para começar a utilizar o LawServices, é essencial configurar algumas opções no menu <b>Configurações</b>.
              Esta é a primeira etapa para aproveitar todas as funcionalidades do nosso software.</p><br>
            <p>Na tela de <b>Configurações</b>, você encontrará:<br>

              <i><b>- Tipo de Ação:</b></i> Cadastre os tipos de ação que serão apresentados na tela de processos.<br>
              <i><b>- Tipo de Documentos:</b></i> Defina os tipos de documentos que você fará upload para os processos.<br>
              <i><b>- Tipo de Documentos de Cliente:</b></i> Configure os tipos de documentos que serão mostrados na tela de cadastro de clientes.<br>
              <i><b>- Tipos de Tarefas:</b></i> Cadastre os diferentes tipos de tarefas que você gerencia no seu dia a dia.</p>
            <p>Complete essas configurações para personalizar o LawServices de acordo com suas necessidades.</p>
          </ng-container>
          <ng-container *ngIf="terceiraPagina">
            <p>A funcionalidade de Atendimento permite que você registre o atendimento inicial do seu cliente.</p>
              <div class="imagem">
                <img src="/assets/Tela de atendimentos.jpeg" width="500"  alt="tela de atendimento"/>
              </div>
                <br>
              <p>- Na tela de Atendimento, você pode cadastrar todas as informações iniciais do atendimento ao cliente.<br>
              - Inclua detalhes relevantes e um resumo dos fatos discutidos durante o atendimento.</p>
          </ng-container>
          <ng-container *ngIf="quartaPagina">
            <p>Com o atendimento devidamente registrado o cliente é criado, no menu <b>Clientes</b> você consegue
              ver e editar todos cadastrados.</p>
            <div class="imagem">
              <img src="/assets/telaclientes.jpeg" width="500"  alt="tela de clientes"/>
            </div>
            <br>
            <p>- Na tela de clientes, você pode cadastrar todas as informações, documentos, contatos e informações bancárias do seu cliente.</p>
          </ng-container>
          <ng-container *ngIf="quintaPagina">
            <p>Chegamos ao principal do LawServices: o cadastro de Processos.<br>
              Na tela de Novo Processo, você encontrará todas as informações necessárias para a criação de um novo processo:</p>
            <div class="imagem">
              <img src="/assets/telaprocessos.jpeg" width="500"  alt="tela de novo processo"/>
            </div>
            <br>
            <p>- Cliente: Selecione o cliente relacionado ao processo.<br>
              - Atendimento: Vincule o atendimento inicial previamente cadastrado para incluir os fatos e detalhes iniciais.<br>
              - Pasta: Escolha ou crie a pasta onde o processo será armazenado.<br>
              - Título: Insira um título claro e descritivo para o processo.<br>
              - Petição Inicial: Adicione a petição inicial que dá início ao processo.</p>
          </ng-container>
          <ng-container *ngIf="sextaPagina">
            <p>CNa tela de Editar Processo, você encontrará todos os campos apresentados na tela de Novo Processo,
              com informações adicionais importantes sobre o processo:</p>
            <br>
            <p>Informações Adicionais:<br>
              - Numeração: Insira ou edite o número do processo.<br>
              - Vara: Informe a vara onde o processo está tramitando.<br>
              - Juiz: Registre o nome do juiz responsável pelo processo.<br>
              - Valores de Causa: Adicione ou atualize os valores envolvidos no processo.<br><br>

              Documentos Cadastrados:<br>
              Visualize, adicione ou edite os documentos associados ao processo.<br><br>
              Tarefas:<br>

              Gerencie as tarefas relacionadas ao processo, mantendo tudo organizado e acessível.<br><br>
              Atendimentos:<br>

              Consulte e edite os atendimentos vinculados ao processo, garantindo que todos os detalhes estejam atualizados.</p>
          </ng-container>
          <ng-container *ngIf="ultimaPagina">
            <h4>Agora sua vez</h4>
            <p>Obrigado por escolher o LawServices!</p>
            <p>Agradecemos por acompanhar nosso tutorial e esperamos que ele tenha sido útil para você. Se precisar
              de qualquer ajuda ou tiver dúvidas, nosso suporte está sempre disponível para você.
              Consulte o menu de Suporte no sistema ou envie um e-mail para <b>suporte&#64;lawservices.com.br</b> </p><br>
             <p> Nossa equipe dedicada está pronta para atendê-lo de forma rápida e eficiente, garantindo que você tenha a
               melhor experiência possível com nosso software.</p>
            <br>
             <p> Além disso, sua opinião é extremamente importante para nós.
              O feedback dos nossos usuários nos ajuda a entender suas necessidades e a melhorar continuamente o LawServices.
              Queremos proporcionar a você um software cada vez mais eficiente e adaptado às suas demandas.
              Por isso, não hesite em compartilhar suas sugestões, críticas e elogios.</p>
               <br>
              <p>Obrigado por confiar no LawServices. Juntos, podemos transformar a gestão do seu escritório de advocacia.</p>
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button *ngIf="!primeiraPagina" (click)="irAnterior()" class="btn btn-primary pull-left text-left"><i class="fa fa-chevron-left"></i> Anterior</button>
          <button *ngIf="!ultimaPagina" (click)="irProximo()" class="btn btn-primary pull-right text-right">Próximo <i class="fa fa-chevron-right"></i> </button>
          <button *ngIf="ultimaPagina" (click)="encerrarTutorial()" class="btn btn-primary pull-right text-right">Finalizar tutorial <i class="fa fa-play-circle"></i> </button>
        </div>
      </div>
    </div>
  </div>
</div>


